import Control from '@/Controls/Control';
import ComponentManager from '@/Management/ComponentManager';
import LinkType from '@/Controls/Link';
import LinkViewModelType from '@/ViewModels/Controls/LinkViewModel';
import LabelType from '@/Controls/Label';
import LabelViewModelType from '@/ViewModels/Controls/LabelViewModel';

export default class AssociationLink extends Control {

    private Link = ComponentManager.getControl<typeof LinkType>('Link');
    private Label = ComponentManager.getControl<typeof LabelType>('Label');
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModelType>('LabelViewModel');
    private LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModelType>('LinkViewModel');
    private jQueryControl: JQuery;
    private links: Array<LinkType | LabelType>;

    public constructor(private viewModel, private element?: JQuery) {
        super(viewModel, element);

        this.onWidgetCreated(this.onWidgetCreatedCallback.bind(this));
    }

    public getControl(): JQuery {
        if (this.jQueryControl != null) {
            return this.jQueryControl;
        }

        this.jQueryControl = this.element || $('<div><div class="c-iterator"><a></div></div>');

        this.widget(null);

        $('<div class="clear">').appendTo(this.jQueryControl);

        return this.jQueryControl;
    }

    private onWidgetCreatedCallback(widget: null): void {
        this.applyBindings(this.jQueryControl, {
            controlName: 'associationlink',

            locator: this.viewModel.locator,

            loader: this.viewModel.isBusy,

            controlIdent: this.identifier,

            tooltip: this.viewModel.tooltip,

            invalid: this.viewModel.invalidationText,

            visible: this.viewModel.isVisible,

            styles: this.definePureComputed({
                read: () => {
                    let styles = ['default'];

                    return styles;
                }
            }),

            states: this.definePureComputed({
                read: () => {
                    let states = [];

                    if (this.viewModel.isRequired() === true) {
                        states.push('required');
                    }

                    if (this.viewModel.isValid() === true) {
                        states.push('valid');
                    } else {
                        states.push('invalid');
                    }

                    if (this.viewModel.isEnabled() === true) {
                        states.push('enabled');
                    } else {
                        states.push('disabled');
                    }

                    return states;
                }
            })
        });

        this.applyBindings(this.jQueryControl.find('.c-iterator'), {
            foreach: {
                data: this.viewModel.values,

                afterRender: (elements, viewModel) => {
                    this.disposeLinks();

                    for (let i = 0; i < elements.length; i++) {
                        let link = null;
                        if (viewModel instanceof this.LinkViewModel) {
                            link = new this.Link(viewModel, $(elements[i]));
                        } else if (viewModel instanceof this.LabelViewModel) {
                            link = new this.Label(viewModel, $(elements[i]));
                        }
                        if (link == null) continue;

                        let tuple = link.getTuple();
                        this.links.push(link);
                    }
                }
            }
        });
    }

    private disposeLinks() {
        if (this.links != null) {
            for (let i = 0; i < this.links.length; i++) {
                this.links[i].dispose();
            }
        }

        this.links = [];
    }
}

ComponentManager.setControl('AssociationLink', AssociationLink, 'RADPresentation.HTMLClient.DefaultViewExtensions');
ComponentManager.setControl('AssoziationLink', AssociationLink, 'RADPresentation.HTMLClient.DefaultViewExtensions');